<template>
  <div class="app outside-page flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="clearfix text-black text-uppercase text-bold text-center" style="position:relative;">
            <h1>404</h1>
            <h2 class="pt-3">Oops! Estas Perdido.</h2>
            <p class=" display-5">La pagina que buscas no existe.</p>
            <router-link class="el-button el-button--primary is-plain" to="/">Regresar</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>



// WEBPACK FOOTER //
// src/views/errors/Page404.vue